import './AdminSearch.scss';
import { useTranslator } from '@Localization';
import _ from 'lodash';
import { ReactElement, useContext, useEffect, useMemo, useState } from 'react';
import { S_TextInput } from '../../../../design/inputs/textInput/S_TextInput';
import { AdminContext } from '../../../../modules/admin/AdminContext';

interface IProps {
  onChange: (value: string) => Promise<void>;
}

export const AdminSearch = ({ onChange }: IProps): ReactElement => {
  const { t } = useTranslator();
  const [searchTerm, setSearchTerm] = useState<string>('');
  const adminContext = useContext(AdminContext);

  useEffect((): void => {
    setSearchTerm(adminContext.search);
  }, [adminContext.search]);

  const handleChange = async (search: string): Promise<void> => {
    setSearchTerm(search);
    adminContext.setSearch(search);
    await debouncedResults(search);
  };

  const debouncedResults = useMemo(() => {
    return _.debounce(onChange, 500);
  }, []);

  return (
    <div className='admin-search'>
      <S_TextInput
        className='admin-search-input'
        value={searchTerm}
        onChange={(search) => {
          void handleChange(search);
        }}
        placeholder={t('search')}
      />
    </div>
  );
};
